import { SocialLoginProvider } from 'components/social_login/SocialLoginButton';
import { ProviderUtils } from './providerUtils';
import { __DEV__ } from 'const/properties';

export const getURIVariable = (loginProvider: SocialLoginProvider) => {
  const urlSubdomain: string | undefined = ProviderUtils.provider?.provider;
  const envProviderKey = `REACT_APP_${loginProvider}_REDIRECT_URI_PROVIDER`;
  const envDefaultKey = `REACT_APP_${loginProvider}_REDIRECT_URI_DEFAULT`;
  const clientIdKey = `REACT_APP_${loginProvider}_CLIENT_ID`;

  if (__DEV__) {
    // localhost
    return [
      process.env[clientIdKey],
      `http://${
        urlSubdomain !== "localhost"
          ? `${urlSubdomain}.${process.env[envProviderKey]}`
          : process.env[envDefaultKey]
      }`,
    ];
  }

  // build result
  return [
    process.env[clientIdKey],
    `https://${
      urlSubdomain
        ? `${urlSubdomain}.${process.env[envProviderKey]}`
        : process.env[envDefaultKey]
    }`,
  ];
};
